module.exports = __webpack_public_path__ + "assets/img/title-73f89ec9.png";